import React, { useEffect, useState } from 'react';

import ComponentType from 'common/src/app/data/enum/ComponentType';
import { withFunctionalClassName } from 'common/src/app/util/componentClassNameUtils';
import { PlaceSummary } from 'common/src/app/types/PlaceSummary';
import { getFormattedPlaceName } from 'common/src/app/util/placesUtils';

import TextNew, { ElementTypes, TextTypes } from 'components/atoms/TextNew';
import Loader from 'components/atoms/Loader';

import { NearestGroupPlacesLandingProps } from './NearestGroupPlacesLanding.types';

import './nearest-group-places-landing.scss';

const NearestGroupPlacesLanding = (
  { goToPlaces, getPlaces }: NearestGroupPlacesLandingProps,
  {},
  className: string,
) => {
  const [places, setPlaces] = useState<PlaceSummary[]>([]);
  const [noResults, setNoResults] = useState<null | boolean>(null);

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      const results = await getPlaces();

      setNoResults(!Array.isArray(results) || results.length === 0);

      if (isMounted) {
        setPlaces(results);
      }
    };

    const timeoutId = setTimeout(() => {
      fetchData();
    }, 100);

    return () => {
      isMounted = false; // prevent state updates
      clearTimeout(timeoutId);
    };
  }, [getPlaces]);

  const handlePlaceChange = (place: PlaceSummary) => {
    const placeName = getFormattedPlaceName(place);

    if (place?.latitude && place?.longitude) {
      goToPlaces(place.latitude, place.longitude, placeName);
    }
  };

  if (noResults) {
    return (
      <div className={className}>
        <TextNew type={TextTypes.ERROR} localeId="nearestGroupPlacesLanding.noResults" />
      </div>
    );
  }

  return (
    <div className={className}>
      {places?.length > 0 && Array.isArray(places) ? (
        <>
          <TextNew
            type={TextTypes.PRIMARY_ORIGINAL}
            element={ElementTypes.H1}
            localeId="nearestGroupPlacesLanding.header"
          />
          <ul>
            {places.map(place => (
              <li key={place.code}>
                <button onClick={() => handlePlaceChange(place)}>
                  <TextNew type={TextTypes.PRIMARY_ORIGINAL}>
                    {getFormattedPlaceName(place)}
                  </TextNew>
                </button>
              </li>
            ))}
          </ul>
        </>
      ) : (
        <Loader />
      )}
    </div>
  );
};

export default withFunctionalClassName(
  ComponentType.TEMPLATE,
  'NearestGroupPlacesLanding',
)(NearestGroupPlacesLanding);
